import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { URLS } from '@wix/da-url';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData } from '@wix/da-bi/pkg/events';
import { useLayoutActions } from '../../../hooks/useLayoutActions';
import { useSelector } from 'react-redux';
import { getModuleCount } from '../../../redux/selectors/modules';
import useGruser from '../../../hooks/useGruser';
import s from './WidgetTypeCard.scss';
const WidgetTypeCard = ({ className, zone, position, installableWidget })=>{
    const { t } = useTranslation();
    const { addModule } = useLayoutActions();
    const logBiEvent = useBiLogger();
    const { hasCoreMembership } = useContext(SessionContext);
    const { gruser } = useGruser();
    const { module: { moduleName, restrict, biReferralType }, widgetCard } = installableWidget;
    const installedCount = useSelector((state)=>getModuleCount(state, gruser, zone, moduleName));
    if (!widgetCard || !addModule) {
        return null;
    }
    const { title, description, minuatureImageSrc, isNew, isDecoratedWithStars } = widgetCard;
    const coreLimit = restrict && restrict.priv === 'core' ? restrict.limit : 0;
    const isCoreOnlyModule = !!coreLimit;
    const needsCoreForThis = isCoreOnlyModule && !hasCoreMembership && installedCount >= ((restrict === null || restrict === void 0 ? void 0 : restrict.limit) || 0);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], isNew && s['new'], isCoreOnlyModule && s['core-only'], isDecoratedWithStars && s['bg-with-stars'], className),
        onClick: ()=>{
            if (needsCoreForThis) {
                // deviation_gruser_port TODO
                // don't forget to set it for the next modules:
                //   case 'papiCustombox':
                //     return ReferralType.CUSTOM_BOX;
                //   case 'userstats':
                //     return ReferralType.USER_STATS;
                const referral_info = biReferralType;
                logBiEvent(BiData({
                    evid: 375,
                    referral_info: referral_info
                }));
                window && window.open(URLS.CORE_MEMBERSHIP, '_blank');
                return;
            }
            addModule(moduleName, position);
            logBiEvent(BiData({
                evid: 283,
                widgetname: moduleName,
                widgetzone: zone
            }));
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['minuature-wrapper'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['miniature'],
        style: {
            backgroundImage: `url(${minuatureImageSrc})`
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title, isNew && /*#__PURE__*/ React.createElement(BetaBadge, {
        className: s['new-badge'],
        size: "small",
        badgeType: "new",
        variant: "green"
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), needsCoreForThis && /*#__PURE__*/ React.createElement("div", {
        className: s['core-upsell-overlay']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['core-upsell-overlay-text']
    }, t('gruser.widgetbox.coreUpsell.becomeCore.toUnlock', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        count: coreLimit,
        coreBadge: /*#__PURE__*/ React.createElement(CoreBadge, {
            size: "small",
            className: s['core-badge']
        }),
        coreLimit
    }))));
};
export default WidgetTypeCard;
